<template>
  <b-modal
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="light"
    centered
    size="xl"
    v-model="open"
    title="Transferência para parceiros"
    :busy="loading"
    :hide-footer="true"
  >
    <b-card>
      <b-row v-if="table.records.length > 0" class="mt-2">
        <b-col cols="12" class="text-center">
          <b-card-text class="fs-20">
            Clique no botão transferir para realizar a transferencia para o parceiro desejado.
          </b-card-text>
        </b-col>

        <b-col cols="12" class="mt-5">
          <b-table
            striped
            responsive
            hover
            :fields="table.headers"
            :items="table.records"
            :busy="loading"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Carregando...</strong>
              </div>
            </template>

            <template #cell(name)="data">
              {{ getNamePartner(data.item.partner_id) }}
            </template>

            <template #cell(actions)="data">
              <b-button
              title="Vincular produto ao parceiro"
                class=""
                @click="sendTransfer(data.item.partner_id)"
                variant="primary"
              >
              transferir
            </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row v-else class="d-flex justify-content-center">
        <h4 class="text-center mt-2">Não Existe Parceiros para receber transferência</h4>
      </b-row>
    </b-card>
    <b-row class="mt-4 d-fle">
      <b-button
        class="ml-3"
        style="width: 47%;"
        @click="closeModal()"
        variant="outline-danger"
      >
        Voltar
      </b-button>
    </b-row>
  </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import { formatMoney } from '@/utils/number';

export default {
  name: 'TransferModal',
  mixins: [makeToast],

  data() {
    return {
      loading: false,
      partners: [],
      idShopkeeper: null,
      open: false,
      table: {
        headers: [
          {
            key: 'name',
            label: 'Parceiro',
            sortable: false,
          },
          {
            key: 'value_partner',
            label: 'Valor Parceiro',
            sortable: false,
            formatter(value) {
              return formatMoney(value)
            }
          },
          {
            key: 'value_shopkeeper',
            label: 'Valor Ganho',
            sortable: false,
            formatter(value) {
              return formatMoney(value)
            }
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
    };
  },
  methods: {
    toggleOpen({ idShopkeeper = null, partners = [] }) {
      this.open = !this.open;
      this.idShopkeeper = idShopkeeper;
      this.partners = partners;
      this.get();
    },
 
    formatMoneyUn(value) {
      return formatMoney(value);
    },

    async get() {
      this.$store.dispatch('startLoader');
      const { data } = await shopkeeperAppApi.get(
        `/products/partners/get-partners-transfer/${this.idShopkeeper}`);

      this.table.records = data.data;
      this.$store.dispatch('endLoader');
    },

    async sendTransfer(idPartner) {
      const sendData = {
        construp_user_id: this.idShopkeeper,
        partner_id: idPartner,
      };

      const { data } = await shopkeeperAppApi.post(
        '/products/partners/transfer-payment-partner', sendData);
      
      if (!data.data.error) {
        this.makeToast(
          'Sucesso',
          `Transferência realizada com sucesso`,
          'success'
        );
      } else {
        this.makeToast(
          'Erro',
          `Houve um erro ao realizar a transferência`,
          'danger'
        );
      }
      
      this.get();
    },

    closeModal(){
      this.open = !this.open;
    },

    getNamePartner(id) {
      const partner = this.partners.find((partner) => partner.partner_id == id);
      return partner ? partner.nome_fantasia : '';
    },
  },
};
</script>
